var parent = require('../../es/set');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;
